/**
 * Chaque objet est un droit possible dans l'application
 */
export class MembreDroit {
    /**
     * Constructeur de l'objet MembreDroit
     * @param row array contenant les données de l'objet
     */
    constructor(row) {
        var _a, _b;
        if (row) {
            this.idMembreDroit = (_a = row.idMembreDroit) !== null && _a !== void 0 ? _a : null;
            this.libelle = (_b = row.libelle) !== null && _b !== void 0 ? _b : null;
        }
    }
    /**
     * Récupération d'un rôle en BDD
     * @return MembreDroit
     */
    static find( /* id: number */) {
        // TODO
    }
    /**
     * Sauvegarde en BDD
     * @return void
     */
    save() {
        // TODO
    }
    /**
     * Retire l'objet de l'affichage en mettant son statut actif à 2.
     * @return void
     */
    delete() {
        // TODO
    }
    /**
     * Utilisée pour renvoyer les informations au front.
     */
    toClient() {
        return {
            libelle: this.libelle,
            idMembreDroit: this.idMembreDroit,
        };
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWVtYnJlRHJvaXQuY2xhc3MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJNZW1icmVEcm9pdC5jbGFzcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7R0FFRztBQUNILE1BQU0sT0FBTyxXQUFXO0lBV3ZCOzs7T0FHRztJQUNILFlBQW1CLEdBQTBCOztRQUM1QyxJQUFJLEdBQUcsRUFBRTtZQUNSLElBQUksQ0FBQyxhQUFhLEdBQUcsTUFBQSxHQUFHLENBQUMsYUFBYSxtQ0FBSSxJQUFJLENBQUM7WUFDL0MsSUFBSSxDQUFDLE9BQU8sR0FBRyxNQUFBLEdBQUcsQ0FBQyxPQUFPLG1DQUFJLElBQUksQ0FBQztTQUNuQztJQUNGLENBQUM7SUFFRDs7O09BR0c7SUFDSSxNQUFNLENBQUMsSUFBSSxFQUFDLGdCQUFnQjtRQUNsQyxPQUFPO0lBQ1IsQ0FBQztJQUVEOzs7T0FHRztJQUNJLElBQUk7UUFDVixPQUFPO0lBQ1IsQ0FBQztJQUVEOzs7T0FHRztJQUNJLE1BQU07UUFDWixPQUFPO0lBQ1IsQ0FBQztJQUVEOztPQUVHO0lBQ0ksUUFBUTtRQUNkLE9BQU87WUFDTixPQUFPLEVBQUUsSUFBSSxDQUFDLE9BQU87WUFDckIsYUFBYSxFQUFFLElBQUksQ0FBQyxhQUFhO1NBQ2pDLENBQUM7SUFDSCxDQUFDO0NBQ0QifQ==